import script from "./LabelSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelSelection.vue?vue&type=script&setup=true&lang=ts"

import "./LabelSelection.vue?vue&type=style&index=0&id=7e72e34c&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e72e34c"]])

export default __exports__